export type OperationProgress = {
  completed: number;
  total: number;
};

export function formatOperationProgressLabel(
  baseLabel: string,
  progress: OperationProgress | null,
  isPending: boolean,
): string {
  if (!isPending) {
    return baseLabel;
  }
  if (progress == null) {
    return `${baseLabel} (…)`;
  }
  return `${baseLabel} (${progress.completed}/${progress.total})`;
}
